'use strict';

import EcsConversation from '@/components/ecs-conversation/EcsConversation';

const getAllConversations = state => [...state.conversations, ...state.history];

const getConversationForElement = state => element => {
  if (!element) {
    return null;
  }
  const elementId = extractProperty('elementId', element);
  const conversation = [...state.conversations, ...state.history].find(
    conversation => conversation.elementId === elementId
  );
  return conversation ? new EcsConversation({ ...conversation }) : null;
};

/**
 * Get all conversations for a given interactionId or interaction object
 * @param state
 * @param {object} EcsConversation
 * @returns {[]}
 */
const getConversationsForInteraction = state => interaction => {
  if (!interaction) {
    return null;
  }
  const interactionId = extractProperty('interactionId', interaction);
  const conversations = [...state.conversations, ...state.history].filter(
    conversation => conversation.interactionId === interactionId
  );
  return conversations.map(conversation => new EcsConversation(conversation));
};

const extractProperty = (prop, from) => {
  const objectProp = typeof from === 'object' ? from[prop] : null;
  return typeof from === 'string' ? from : objectProp;
};

export default {
  getAllConversations,
  getConversationForElement,
  getConversationsForInteraction
};
